var PanelType;
(function (PanelType) {
    PanelType[PanelType["FPS"] = 0] = "FPS";
    PanelType[PanelType["MS"] = 1] = "MS";
    PanelType[PanelType["MEMORY"] = 2] = "MEMORY";
    PanelType[PanelType["RENDER_MODES"] = 3] = "RENDER_MODES";
})(PanelType || (PanelType = {}));
export { PanelType };
